import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const TravelLogPage = lazy(() => import("./TravelLogPage"));
const LocationPage = lazy(() => import("./LocationPage"));

export type TravelLogPagesNavigationParams = {
  travelLogSchedule: PageNavParams;
  travelLogScheduleDate: PageNavParams<{ date: string }, { search?: string }>;
  travelLogLocation: PageNavParams<{ userId: string; date: string }>;
};

export const travelLogPagesNavigationConfig: ModulePagesConfig<TravelLogPagesNavigationParams> =
  {
    travelLogSchedule: {
      element: <TravelLogPage />,
      path: "travel-log",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.travelLog,
      requiredModules: [SubscriptionPlanModuleId.timeLog],
    },
    travelLogScheduleDate: {
      element: <TravelLogPage />,
      path: "travel-log/:date",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.travelLog,
      requiredModules: [SubscriptionPlanModuleId.timeLog],
    },
    travelLogLocation: {
      element: <LocationPage />,
      path: "travel-log/location/:userId/:date",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.travelLog,
      requiredModules: [SubscriptionPlanModuleId.timeLog],
    },
  };
